import React from 'react';

import { ZERO_X } from '../constants.js';
import Tile from './Tile.js';
import './Tiles.css';

export default (props) => {
    const {
        checkFunction,
        currentAddress,
        showNotification,
        tiles,
        isDisabled,
        winningX,
        winningY,
    } = props;

    return (
        <div className="tiles-container">
            {tiles.map((row, x) => (
              <div className="tiles-row" key={x}>
                {row.map((tile, y) => (
                  <Tile
                    address={tile.address}
                    checkFunction={checkFunction}
                    isClaimed={tile.isClaimed}
                    isClaimedByCurrentAddress={tile.address === currentAddress}
                    shouldShownotification={!currentAddress}
                    isDisabled={isDisabled}
                    isLoading={tile.isLoading}
                    key={`${x}${y}`}
                    showHero={tile.address !== ZERO_X}
                    showNotification={showNotification}
                    xCoord={x}
                    yCoord={y}
                    isWinner={x === winningX && y === winningY }
                  />
                ))}
              </div>
            ))}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Tiles.js